module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.closeTransition ? '' : 'md-fade-center'
    }
  }, [_c('span', {
    staticClass: "zk-tag",
    class: [_vm.type ? 'zk-tag--' + _vm.type : '', {
      'is-hit': _vm.hit
    }]
  }, [_vm._t("default"), _vm._v(" "), (_vm.closable) ? _c('i', {
    staticClass: "zk-tag__close zk-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-eb61b102"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/tag/src/tag.vue
// module id = 285
// module chunks = 0